<template>
  <div class="activeType">
    <!--  -->
    <div v-if="createStep == 1">
      <!-- 顶部活动描述 -->
      <div class="activeType_top" v-show="actItemInfo">
        <div class="content-left" v-if="fitersChooseIF([42], '!=')">
          <el-carousel
            v-if="activityData.createStep == 8"
            class="carousel-box"
            indicator-position="none"
            arrow="never"
          >
            <el-carousel-item v-for="item1 in imgList" :key="item1">
              <img :src="item1" alt="" />
            </el-carousel-item>
          </el-carousel>
          <img
            v-else
            :src="activityData.bghome"
            style="
              width: 93%;
              top: 50%;
              position: absolute;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            alt=""
          />
        </div>
        <div class="content-right" v-if="fitersChooseIF([42], '!=')">
          <div class="sign">
            {{ activityData.title
            }}<span
              v-if="fitersChooseIF([35, 37], '!=')"
              class="sign_jc pointer"
              @click="handleWord()"
              >使用教程</span
            >
          </div>
          <span class="sign_desc">{{ activityData.content }}</span>
          <div class="QRcode" v-if="fitersChooseIF([35], '!=')">
            <div class="QRcode_img" id="QRcode_img" ref="QRcode_img"></div>
            <span>京东APP扫码预览</span>
            <div class="QRcode_btn pointer" @click="handleRoute()">
              创建活动
            </div>
          </div>
          <!-- 积分锁权按钮 -->
          <div v-else class="QRcode_btn pointer" @click="handleRoute()">
            创建活动
          </div>
        </div>
        <!-- 随单发 -->
        <div v-if="fitersChooseIF([42])">
          <div
            class="sign"
            style="font-size: 18px;font-weight: 600;margin-bottom: 20px;"
          >
            {{ activityData.title }}
          </div>
          <span class="sign_desc">{{ activityData.content }}</span>
          <div>
            <div
              class="QRcode_btn pointer"
              @click="handleRoute()"
              style="margin-bottom: 25px;margin-top: 25px;"
            >
              创建活动
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-point tipBg"
        v-show="actItemInfo"
        v-if="fitersChooseIF([19, 16, 17, 18, 27, 28])"
      >
        <div class="card-rule" style="width: 45px">注：</div>
        <template v-if="venderType">
          <div class="card-connet" v-if="orderCRM">
            <p>
              1、自营店铺需要搭配<span style="color: #7b61ff">云短信CRM</span
              >使用,<span
                style="color: #7b61ff"
                @click="handleCreate"
                class="pointer"
                >前往订购>></span
              >
            </p>
            <p>2、订单完成后发放奖励。</p>
          </div>
          <div class="card-connet" v-else>
            <p>
              1、云短信CRM：订购到期时间
              {{ orderCRMtime }}（自营店铺需要搭配<span
                @click="handleCreate"
                class="pointer"
                style="color: #7b61ff"
                >云短信CRM</span
              >使用）。
            </p>
            <p>2、订单完成后发放奖励。</p>
          </div>
        </template>
        <div class="card-connet" v-else>
          <p>1、订单完成后发放奖励。</p>
        </div>
      </div>
      <div
        class="tishi tipBg"
        v-show="actItemInfo"
        v-if="fitersChooseIF([13, 14, 15])"
      >
        <span class="desc">
          <i class="el-alert__icon el-icon-info" style="color:#7B61FF;"></i>
          官方规则：店铺礼包和开卡礼包为同类型活动，每个店铺只能存在1个进行中礼包活动（并与其他系统同步）且不支持预创建，所以店铺礼包在哪里创建的也只能在哪里关闭哦。
        </span>
      </div>
      <div
        class="card-point tipBg"
        v-show="actItemInfo"
        v-if="fitersChooseIF([36])"
      >
        <div class="card-rule" style="width: 45px">注：</div>
        <template>
          <!-- 自营 -->
          <div class="card-connet" v-if="orderCRM">
            <p>
              1、自营店铺需搭配<span style="color: #7b61ff">云起云舟</span>使用
              , 详情请咨询客服。
            </p>
            <p>2、订单完成后发放奖励。</p>
          </div>
          <!-- pop -->
          <div class="card-connet" v-else>
            <p>
              1、云短信CRM{{
                orderCRMtime.length > 0 ? "：订购到期时间 " + orderCRMtime : ""
              }}（店铺需要搭配<span
                @click="handleCreate"
                class="pointer"
                style="color: #7b61ff"
                >云短信CRM</span
              >使用）。
            </p>
            <p>2、订单完成后发放奖励。</p>
          </div>
        </template>
      </div>

      <!-- tab切换 -->
      <div class="tabSwitch" v-show="actItemInfo">
        <template v-for="(item, index) in tabSwitchList">
          <div
            class="tabSwitch-wz"
            @click="handleTab(index)"
            :key="index"
            :class="{ active: index == currIndex }"
            v-if="
              (fitersChooseIF([24, 35, 37, 42]) && index == 1) ||
                (fitersChooseIF([35, 37, 42]) && index == 2) ||
                (!fitersChooseIF([24, 35, 37, 42]) && index != 2)
            "
          >
            {{ item }}
          </div>
        </template>
      </div>
      <template v-if="currIndex == 1 || currIndex == 2">
        <giftListVue
          style="margin: -24px; margin-top: 24px"
          v-if="fitersChooseIF([9, 10, 29, 30, 38,55,58,59,60,61])"
          :statisType="2"
          :inputShow="false"
          :inputShow1="true"
          :activityType="activityData.id"
          @statisDataCreate="statisDataCreate"
          @handleshow="handleshow"
          :top="true"
        />
        <tableAct
          v-else
          :key="currIndex"
          :isDraft="fitersChooseIF([35, 37, 42]) && currIndex == 2"
          @handleshow="handleshow"
          :type="
            fitersChooseIF([35])
              ? 35
              : fitersChooseIF([36])
              ? 36
              : fitersChooseIF([37])
              ? 37
              : fitersChooseIF([42])
              ? 42
              : null
          "
        />
      </template>
      <template v-else>
        <el-form
          v-if="this.fitersChooseIF([13, 14, 15, 27, 28, 34])"
          ref="form"
          class="formClass"
          :model="form"
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="模板名称：">
            <el-input
              style=""
              size="small"
              placeholder="请输入"
              v-model="form.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="模板ID：">
            <el-input
              size="small"
              placeholder="请输入"
              v-model="form.id"
            ></el-input>
          </el-form-item>

          <div class="seach_btn">
            <el-button size="small" class="search" @click="handkeSearch(0)">
              查询
            </el-button>
            <el-button size="small" class="reset" @click="handkeSearch(1)"
              >重置</el-button
            >
          </div>
        </el-form>
        <!--  -->
        <div
          class="activeType_bottom"
          v-loading="loading"
          style="margin-top: 24px"
        >
          <div class="template">
            <div style="width: 82px; padding-top: 5px">模板类型：</div>
            <div class="template-nav">
              <div
                class="template-wz pointer"
                v-for="(item, index) in tempSwitchList"
                :key="item.id"
                @click="handleTem(item, index)"
                :class="{ activeTem: index == tempIndex }"
                v-show="item.isVisible"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <!-- m模板图 -->
          <div class="templateBox">
            <!-- 自定义上传 -->
            <div class="temImg" v-if="tempItem.title == '自定义上传'">
              <div
                class="temImg_content pointer"
                @click="visibleUpload = true"
                style="border: 1px solid rgba(123, 97, 255, 0.15)"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <!-- <img src="@/assets/thdImg/pages/dz.svg" alt="" /> -->
                    <span>上传图片</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05)"
                ></div>
              </div>
            </div>
            <!-- 定制 -->
            <div class="temImg" v-else>
              <div
                class="temImg_content"
                style="border: 1px solid rgba(123, 97, 255, 0.15)"
              >
                <div class="temImg_content_img temImg_dz">
                  <div class="temImg_dz_center">
                    <img src="@/assets/thdImg/pages/dz.svg" alt="" />
                    <span>品牌定制</span>
                  </div>
                </div>
                <div
                  class="temImg_content_wz"
                  style="background: rgba(123, 97, 255, 0.05)"
                ></div>
              </div>
              <!-- hover -->
              <div
                class="temImg_content_bgshadow"
                style="height: 432px; border-radius: 8px"
                @click="handleOpen()"
              >
                <div class="temImg_content_bgshadow_codeDZ">
                  <img
                    style="width: 100%"
                    src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <!-- 模板 -->
            <div
              class="temImg"
              v-for="(item, index) in giftList"
              :key="item.id"
            >
              <div class="temImg_content">
                <div class="temImg_content_img">
                  <img
                    class="imgs"
                    style="width: 100%"
                    :src="item.imgUrl"
                    alt=""
                  />
                  <img
                    v-if="item.days"
                    class="temImg_content_img_free"
                    src="@/assets/thdImg/common/free.svg"
                    alt=""
                    srcset=""
                  />
                  <div v-if="item.days" class="temImg_content_img_time">
                    倒计时：{{ item.days }}
                  </div>
                </div>
                <div class="temImg_content_wz">
                  <span class="temImg_title">{{ item.name }}</span>
                  <span class="temImg_desc">模板ID：{{ item.id }}</span>
                </div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow">
                <div
                  class="temImg_content_bgshadow_code qrCodeIMG"
                  id="qrCodeIMG"
                  ref="qrCodeIMG"
                  :style="{
                    marginTop:
                      item.prizeType != '[]' && fitersChooseIF([13, 14, 15])
                        ? '80px'
                        : '',
                  }"
                ></div>
                <div class="temImg_content_bgshadow_codeDesc">
                  手机扫码预览模板
                </div>
                <div
                  class="temImg_content_bgshadow_jx"
                  v-if="
                    fitersChooseIF([13, 14, 15]) &&
                      item.prizeType != '[]' &&
                      item.prizeType
                  "
                >
                  <div>
                    奖项：最多支持{{
                      item.awardNumLimit || item.prizeType.split(",").length
                    }}个奖品
                  </div>
                  <div>
                    （{{
                      item.prizeType
                        .replace("1", "店铺积分")
                        .replace("2", "京豆")
                        .replace("3", "京券")
                        .replace("4", "东券")
                        .replace(/,/g, "、")
                    }}）
                  </div>
                </div>
                <div
                  style="display: flex"
                  v-if="tempItem.title == '自定义上传'"
                >
                  <div
                    class="temImg_content_bgshadow_btn pointer"
                    @click="handleSet(item, index)"
                  >
                    使用此模板
                  </div>
                  <div
                    class="temImg_content_bgshadow_btn pointer"
                    @click="handleDel(item)"
                  >
                    删除模板
                  </div>
                </div>
                <div
                  v-else
                  class="temImg_content_bgshadow_btn pointer"
                  @click="handleSet(item, index)"
                >
                  使用此模板
                </div>
              </div>
            </div>
          </div>
          <br />
          <!-- 分页 -->
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageData.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="pageData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            style="text-align: right;margin-top: 20px;"
          >
          </el-pagination> -->
        </div>
      </template>
    </div>
    <statistics
      v-if="createStep == 3 && !isNew"
      @returnStep="returnStep"
      :rowData="rowData"
      :ids1="ids1"
      @triggerVersion="triggerVersion"
    ></statistics>
    <!-- 数据统计-新版 -->
    <statistics-new
      style="background-color: #fff"
      v-if="createStep == 3 && isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics-new>
    <!-- <createAct v-if="createStep == 2" @goBack="back"></createAct> -->

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span
        style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px"
        >是否删除此模板？</span
      >
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="outerVisible = false">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 创建活动步骤 -->
    <create-activity-step
      ref="createStep2"
      v-if="createStep == 2"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      :activityDataInfo="activityDataInfo"
      @titopName="titopName"
    ></create-activity-step>
    <!-- 邀请开卡 -->
    <create-invite-step
      ref="createStep5"
      v-if="createStep == 5"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-invite-step>
    <!-- 电铺礼包千人千面 -->
    <create-task-electric
      ref="createStep11"
      v-if="createStep == 11"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-task-electric>
    <!-- 首单  复购 下单有礼 -->
    <create-task-Polite
      ref="createStep4"
      v-if="createStep == 4"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-task-Polite>
    <create-task-evaluation
      v-if="createStep == 6"
      ref="createStep6"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-task-evaluation>
    <create-task-book
      ref="createStep7"
      v-if="createStep == 7"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-task-book>
    <!-- 游戏 -->
    <points-task-games
      ref="createStep10"
      @saveEdit="saveEditChange"
      v-if="createStep == 10"
      @returnBack="returnBackChange"
      :activityData="activityData"
    ></points-task-games>
    <!-- 大转盘创建活动步骤 -->
    <create-activity-step1
      ref="createStep8"
      v-if="createStep == 8"
      @returnBack="returnBackChange"
      :activityData="activityData"
    ></create-activity-step1>
    <!-- 下单抽奖 -->
    <create-activity-step2
      ref="createStep9"
      v-if="createStep == 9"
      @returnBack="returnBackChange"
      :activityData="activityData"
    ></create-activity-step2>

    <!-- 创建积分优惠券 -->
    <create-coupons
      ref="createStep13"
      :isShow="createStep == 13"
      v-if="createStep == 13"
      :tabActive="activityData.id"
      :activityData="activityData"
      @return="returnBackChange"
    ></create-coupons>
    <!-- 创建积分优惠券 -->
    <create-coupons2
      ref="createStep14"
      :isShow="createStep == 14"
      v-if="createStep == 14"
      :tabActive="activityData.id"
      @returnback="returnBackChange"
    ></create-coupons2>
    <!-- 超级裂变神券 -->
    <create-task-superFission
      v-if="createStep == 15"
      ref="createStep15"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></create-task-superFission>
    <!-- 兑换红包 -->
    <create-exchange-cash-red
      ref="createStep38"
      :isShow="createStep == 38"
      v-if="createStep == 38"
      :tabActive="activityData.id"
      @returnback="returnBackChange"
    ></create-exchange-cash-red>
    <!-- 积分锁权 -->
    <points-task-pointLockAuth
      v-if="createStep == 16"
      ref="createStep16"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      :activityData="activityData"
      @titopName="titopName"
    ></points-task-pointLockAuth>
    <!-- 下单抽奖 -->
    <create-Activity-Order
      ref="createStep36"
      v-if="createStep == 36"
      @returnBack="returnBackChange"
      :activityData="activityData"
    ></create-Activity-Order>
    <!-- 派样回购礼 -->
    <create-Send-Re-Buy
      v-if="createStep == 37"
      ref="createStep37"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      @titopName="titopName"
    ></create-Send-Re-Buy>
    <!-- 派样回购（随单发） -->
    <create-shop-Re-Buy
      v-if="createStep == 42"
      ref="createStep42"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      @titopName="titopName"
    ></create-shop-Re-Buy>
    <!-- 生日有礼 -->
    <create-brithday
      v-if="createStep == 39"
      ref="createStep39"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></create-brithday>
    <!-- 会员升级礼 -->
    <member-upgrade-page
      v-if="createStep == 44"
      ref="createStep44"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></member-upgrade-page>
    <!-- 会员升级礼 -->
    <billetDouxGreetingCard
      v-if="createStep == 50"
      ref="createStep50"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
    ></billetDouxGreetingCard>
    <!-- 晒单有礼 -->
    <create-singles-politely
      v-if="createStep == 41"
      ref="createStep41"
      :activityData="activityData"
      @returnBack="returnBackChange"
      @saveEdit="saveEditChange"
      @titopName="titopName"
    ></create-singles-politely>
     <!-- 积分兑换礼品卡/爱奇艺/百度网盘/PLUS会员 -->
     <create-exchange-common
      :ref="createStepText"
      :isShow="[58,59,60,61].includes(createStep)"
      v-if="[58,59,60,61].includes(createStep)"
      :activityData="activityData"
      :tabActive="activityData.id"
      @returnback="returnBackChange"
    ></create-exchange-common>
    <uploadPopup :visible.sync="visibleUpload" @handleSave="handleSave" />
  </div>
</template>

<script>
import tableAct from "./table.vue";
import statistics from "../activity_data_statistics";
import statisticsNew from "../activity_data_statistics_new.vue";
// import createAct from "../huodongedit/index.vue";
import createActivityStep from "../points_task_activity.vue";
import createInviteStep from "../points_task_Invite";
import activityManage from "../activityManage";
import createTaskPolite from "../points_task_polite.vue";
import createTaskElectric from "../points_task_electric.vue";
import createTaskEvaluation from "../points_task_evaluation.vue";
import createTaskBook from "../points_task_book.vue";
import pointsTaskGames from "../points_task_games.vue";
import pointsTaskPointLockAuth from "../points_task_pointLockAuth.vue";
import createActivityStep1 from "../create_activity_step.vue";
import createActivityStep2 from "../create_activity_step2.vue";
import createCoupons from "../create_coupons";
import createCoupons2 from "../create_coupons2";
import createBrithday from "../create-brithday";
import memberUpgradePage from "@/views/integralCenter/member_upgrade_page.vue";
import billetDouxGreetingCard from "@/views/integralCenter/billet-doux-greeting-card.vue";
import giftTmp from "./giftTmp.js";
import giftListVue from "../gift_list.vue";
import createTaskSuperFission from "../points_task_superFission.vue";
import createExchangeCashRed from "../create_exchangeCashRed.vue";
import createActivityOrder from "../create_activity_order";
import createSendReBuy from "../create_sendReBuy.vue";
import createShopReBuy from "../create_shopReBuy.vue";
import uploadPopup from "../../../components/uploadPopup.vue";
import createExchangeCommon from "../create_exchange_common.vue";
import {
  giftBagTemplate,
  templateDelete,
  checkOpenCrmByVenderType,
} from "@/api/public.js";
import { mapState } from "vuex";
import createSinglesPolitely from "../create_singles_politely.vue";
export default {
  name: "activeType",
  mixins: [giftTmp],
  computed: {
    ...mapState(["venderType"]),
    // 判断是否为丸美店铺
    isWM() {
      // console.log(this.$store.getters.loginUserInfo, "店铺信息");
      let data;
      if (this.$store.getters.loginUserInfo.venderId == "1000003788") {
        data = true;
      } else {
        data = false;
      }
      return data;
    },
    createStepText() {
      return "createStep" + this.activityData.id
    }
  },
  components: {
    giftListVue,
    createCoupons,
    createCoupons2,
    tableAct,
    statistics,
    statisticsNew,
    createActivityStep,
    createInviteStep,
    activityManage,
    createTaskElectric,
    createTaskEvaluation,
    createTaskBook,
    pointsTaskGames,
    createTaskPolite,
    createActivityStep1,
    createActivityStep2,
    createTaskSuperFission,
    createExchangeCashRed,
    pointsTaskPointLockAuth,
    createActivityOrder,
    uploadPopup,
    createSendReBuy,
    createBrithday,
    createSinglesPolitely,
    createShopReBuy, //派样回购随单发
    memberUpgradePage, // 会员升级礼
    billetDouxGreetingCard, // 情书贺卡
    createExchangeCommon,// 积分兑换礼品卡/爱奇艺/百度网盘/PLUS会员
  },
  data() {
    return {
      imgList: [
        require("@/assets/thdImg/xingyun/card0.png"),
        require("@/assets/thdImg/xingyun/card1.png"),
      ],
      visibleUpload: false,
      tabActive: 0,
      couponsIsShow1: false,
      couponsIsShow: false,
      actItemInfo: true,
      statisticsShow: 1,
      tabSwitchList: ["玩法模板", "活动管理", "草稿箱"],
      currIndex: 0,
      createStep: 1,
      ids1: "",
      rowData: {},
      outerVisible: false,
      giftItem: {},
      isNew: false,
      // tempIndex: 0,
      // tempSwitchList: ["全部", "618", "双11", "双12"],
      // activityData: {},
    };
  },
  watch: {
    // 模板id只能输入数字
    "form.id"(newVal, oldVal) {
      let nums = /^[0-9]*$/;
      if (!nums.test(newVal)) {
        this.form.id = oldVal;
      }
    },
  },
  created() {
    if (this.fitersChooseIF([24, 35, 37, 42])) {
      this.currIndex = 1;
    }
    if (this.$route.query.type == 1) {
      this.handleRoute();
    }
    console.log(this.activityData, "-----activityData");
    console.log(this.$store.getters.loginUserInfo, "店铺信息");
  },

  methods: {
    // 新版本切换
    triggerVersion(val) {
      this.isNew = val;
    },
    // 自定义保存
    handleSave(obj) {
      giftBagTemplate({ ...obj, templateDirId: this.tempItem.id }).then(
        (res) => {
          if (res.code == 1) {
            this.visibleUpload = false;
            this.getPolite();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
        }
      );
    },
    handleDel(item) {
      this.outerVisible = true;
      this.giftItem = item;
    },
    handleDeleteTable() {
      templateDelete(this.giftItem.id).then((res) => {
        if (res.code == 1) {
          this.outerVisible = false;
          this.getPolite();
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleWord() {
      if (this.activityData.course) {
        window.open(this.activityData.course, "_blank");
      }
    },
    statisDatainfo() {
      this.createStep = 9999;
    },
    statisDataCreate(row) {
      this.rowData = row;
      this.ids1 = row.id;
      this.createStep = 3;
      // 判断活动时间是否为新版
      this.isNew = this.isCurrentTimeAfter(row.updateTime);
      this.handleshow(false);
    },
    // 创建活动
    async handleRoute() {
      if (this.fitersChooseIF([36])) {
        let {
          code: code,
          message: message,
          data: data,
        } = await checkOpenCrmByVenderType();
        console.log(code, message, data);
        if (code == 1) {
          this.orderCRMtime = data;
          this.createStep = this.activityData.createStep;
          this.$nextTick(() => {
            this.$refs[refName].nextStepKai(item, item.id);
          });
        } else {
          if (message) {
            this.$message.warning(message);
            return;
          } else {
            this.$message.warning(data.message);
            return;
          }
        }
      } else {
        this.createStep = this.activityData.createStep;
      }
    },
    // tab切换
    handleTab(i) {
      this.currIndex = i;
      if (i == 0) {
        this.$nextTick(() => {
          this.getCodeIMG1();
        });
      }
    },
    handkeSearch(i) {
      if (i == 1) {
        this.form.name = "";
        this.form.id = "";
      }
      this.pageData.current = 1;
      if (this.fitersChooseIF([13, 14, 15])) this.getPolite();
      if (this.fitersChooseIF([27, 28, 34])) this.getPolitely();
      // if (this.fitersChooseIF([34])) this.getPolitely();
    },
    handleshow(row) {
      this.actItemInfo = row;
    },
    returnStep() {
      this.actItemInfo = true;
      this.createStep = 1;
      this.$nextTick(() => {
        this.getCodeIMG();
        this.getCodeIMG1();
      });
    },
    returnBackChange() {
      this.createStep = 1;
      this.$nextTick(() => {
        this.getCodeIMG();
        this.getCodeIMG1();
      });
    },
    saveEditChange() {
      this.createStep = 1;
      // this.tabActive = 2;
      this.handleTab(1);
    },
    titopName(name, val) {
      // this.isTopTitle = val;
      // this.titleName = name;
    },
    back() {
      this.createStep = 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tishi {
  // height: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  background: #fffaee;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 14px 20px;
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.activeType {
  // width: 98%;
  margin: 24px;
  padding: 24px;
  // min-height: 1062px;
  background: #ffffff;
  padding-bottom: 0;
  &_top {
    display: flex;
    .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;
    }
    .content-right {
      flex: 1;
      margin-left: 33px;
      margin-top: 16px;
    }
    .sign {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: end;
      &_jc {
        font-size: 14px;
        color: #999999;
        margin-left: 20px;
        display: flex;
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 4px;
          background: url("../../../assets/thdImg/pages/question.svg") no-repeat;
        }
      }
    }
    .sign_desc {
      font-size: 14px;
      color: #666666;
    }
    .QRcode {
      width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #000000;
      margin-top: 50px;

      &_img {
        width: 100%;
        height: 150px;
        // background: #7b61ff;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
        box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        padding: 7px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          width: 19px;
          height: 19px;
          margin-right: 5px;
          background: url("../../../assets/thdImg/pages/create.svg") no-repeat;
        }
      }
    }
  }
  .tabSwitch {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    // padding: 0 20px;
    position: relative;
    height: 50px;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #f6f6f6;
    &-wz {
      height: 50px;
      line-height: 50px;
      position: relative;
      margin-right: 24px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .active {
      color: #7b61ff;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 100%;
        height: 2px;
        background-color: #7b61ff;
        transition: all 0.2s;
        animation: opation 0.2s;
      }
      @keyframes opation {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 100%;
        }
      }
    }
  }
  .formClass {
    margin: 24px 0;
    display: flex;
    /deep/.el-form-item {
      margin-right: 50px;
    }
    .seach_btn {
      margin-left: auto;
      margin-right: 30px;
      display: flex;
    }
    .search,
    .reset {
      width: 98px;
      font-size: 14px;
      height: 32px;
      transition: all 0.2s;
      border-radius: 4px 4px 4px 4px;
    }
    .search {
      color: #fff;
      background-color: #7b61ff;
      &:hover {
        opacity: 0.8;
      }
    }
    .reset {
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background: rgba(38, 112, 251, 0.1);
      }
    }
  }
  &_bottom {
    padding-bottom: 24px;
    .template {
      display: flex;
      color: #333333;
      // align-items: center;
      margin-bottom: 16px;
      &-nav {
        display: flex;
        flex-wrap: wrap;
      }
      &-wz {
        padding: 4px 8px;
        color: #666666;
        background: #f8f8fb;
        border-radius: 4px;
        margin-left: 12px;
        margin-bottom: 10px;
        &:hover {
          background: #7b61ff;
          border-radius: 4px;
          color: #ffffff;
        }
      }
      .activeTem {
        background: #7b61ff;
        border-radius: 4px;
        color: #ffffff;
      }
    }
    .templateBox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .temImg {
      width: 224px;
      height: 453px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 41px;
      &:hover .temImg_content_bgshadow {
        opacity: 0;
        animation: key3 0.5s forwards;
      }
      @keyframes key3 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0.3;
        }
        100% {
          opacity: 1;
        }
      }
      .temImg_content_bgshadow {
        z-index: 123;
        opacity: 0;
        position: absolute;
        // left: -1;
        top: 10px;
        width: 100%;
        height: 380px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 8px 8px 0px 0px;
        transform: scale(1.05);
        &_code {
          margin: 0 auto;
          margin-top: 125px;
          width: 150px;
          height: 150px;
          background: #ffffff;
          border-radius: 4px;
          padding: 5px;
        }
        &_codeDZ {
          margin: 0 auto;
          margin-top: 84px;
          width: 180px;
          border-radius: 4px;
          padding: 5px;
        }
        &_codeDesc {
          margin: 0 auto;
          margin-top: 15px;
          width: 112px;
          color: #ffffff;
        }
        &_btn {
          margin: 0 auto;
          margin-top: 25px;
          width: 86px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #7b61ff;
          border-radius: 4px;
          color: #ffffff;
        }
        &_jx {
          margin-top: 9px;
          color: #fff;
          text-align: center;
          line-height: 18px;
          opacity: 0.7;
        }
      }
      &_content {
        width: 100%;
        height: 433px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: 0.6s linear;
        &_img {
          width: 100%;
          height: 380px;
          overflow: hidden;
          border-radius: 8px 8px 0px 0px;
          background: #666;
          // background: rgba(38, 112, 251, 0.05);
          // transition: 0.6s linear;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          &_free {
            position: absolute;
            right: 0px;
            top: 0px;
            transition-delay: 1s;
            transition: transform 0.3s linear, -webkit-transform 0.3s linear;
          }
          &_time {
            right: 1px;
            position: absolute;
            font-weight: 500;
            color: #fff;
            bottom: 0px;
            background-color: rgba(0, 0, 0, 0.7);
            padding: 9px 7px;
            border-top-left-radius: 13px;
            transition: transform 0.3s linear, -webkit-transform 0.3s linear;
          }
          .imgs {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        &_wz {
          width: 100%;
          height: 53px;
          padding: 10px 12px;
        }
      }

      &:hover {
        .temImg_content {
          box-shadow: 0px 12px 25px 1px rgba(0, 0, 0, 0.15);
          border-radius: 8px;
          transform: scale(1.05);
          transition: transform 0.3s, -webkit-transform 0.3s;
        }
      }
      &_dz {
        width: 100%;
        // height: 433px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(123, 97, 255, 0.05) !important;

        &_center {
          > img {
            margin: 0 auto;
            display: block;
          }
          > span {
            font-size: 20px;
            font-weight: bold;
            margin-top: 12px;
            display: block;
          }
        }
      }
      &_title {
        display: block;
        color: #333333;
      }
      &_desc {
        display: block;
        font-size: 12px;
        line-height: 23px;
        color: #999;
      }
    }
    @media screen and (min-width: 1350px) and (max-width: 1700px) {
      .temImg {
        margin-right: 26px !important;
      }
    }
  }
}

.buttonBox {
  .b1 {
    width: 98px;
    height: 32px;
    color: #666666;
    // position: absolute;
    border-radius: 3px;
    margin-top: 20px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #7b61ff;
      border: 1px solid #7b61ff;
      background-color: rgba(123, 97, 255, 0.05);
    }
  }
  .b2 {
    width: 98px;
    // position: absolute;
    // margin-right: 80px;
    height: 32px;
    margin: 20px 80px 10px 10px;
    border: 1px solid #7b61ff;
    color: #ffffff;
    border-radius: 3px;
    background-color: #7b61ff;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #7b61ff;
    }
  }
}
.shopReBuy {
  margin-left: -500px;
}

.content-left {
  /deep/.el-carousel {
    width: 184px !important;
    height: 336px !important;
    border-radius: 12px !important;
    .el-carousel__item {
      width: 100%;
      height: 100%;
      padding: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  /deep/.el-carousel__container {
    width: 184px !important;
    height: 336px !important;
    border-radius: 12px;
  }
}
</style>
